import React from 'react';
import { Box, Typography, Paper, Button, CircularProgress } from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ComingSoon = ({ 
  title = 'Coming Soon', 
  description = 'This feature is currently under development', 
  icon, 
  showButton = true,
  buttonText = 'Go to Dashboard',
  buttonPath
}) => {
  const navigate = useNavigate();
  const { userRole } = useAuth();

  const getDefaultPath = () => {
    if (userRole === 'bda') return '/bda/dashboard';
    if (userRole === 'sp_admin' || userRole === 'sp_staff') return '/sp/dashboard';
    return '/dashboard';
  };

  const handleRedirect = () => {
    navigate(buttonPath || getDefaultPath());
  };
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 4,
          borderRadius: 4,
          textAlign: 'center',
          backgroundColor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
          maxWidth: 500,
          mx: 'auto',
          mt: 2
        }}
      >
        {icon ? (
          <Box sx={{ mb: 3, color: 'primary.main', display: 'flex', justifyContent: 'center' }}>
            {icon}
          </Box>
        ) : (
          <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
            <CircularProgress 
              variant="determinate" 
              value={75} 
              size={60} 
              thickness={4}
              sx={{ color: 'primary.main' }}
            />
          </Box>
        )}
        
        <Typography variant="h5" component="h2" fontWeight={600} gutterBottom>
          {title}
        </Typography>
        
        <Typography variant="body1" color="text.secondary" paragraph>
          {description}
        </Typography>
        
        {showButton && (
          <Button 
            variant="contained" 
            color="primary"
            onClick={handleRedirect}
            sx={{ mt: 2, borderRadius: 3, px: 3, py: 1 }}
          >
            {buttonText}
          </Button>
        )}
      </Paper>
    </motion.div>
  );
};

export default ComingSoon; 